import { IconBase, type IconProps } from './iconBase';

import type { JSX } from 'react';

export const Send = ({ type, ...rest }: IconProps): JSX.Element => (
  <IconBase viewBox='0 0 24 25' {...rest}>
    {type === 'stroke' ? (
      <path
        d='M6 12.438h3m-3 0L3.752 5.693c-.28-.84.59-1.602 1.386-1.215l14.514 7.06a1 1 0 0 1 0 1.8l-14.514 7.06c-.796.387-1.666-.375-1.386-1.216z'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    ) : (
      <path
        d='M5.466 3.804C4.072 3.126 2.55 4.46 3.04 5.93l1.92 5.757H9a.75.75 0 0 1 0 1.5H4.96l-1.92 5.757c-.49 1.47 1.032 2.805 2.426 2.127l14.514-7.06c1.312-.639 1.312-2.51 0-3.148z'
        fill='currentColor'
      />
    )}
  </IconBase>
);
